import React, { useState } from 'react';
import { CartController } from '../helpers/CartController';


export const CartContext = React.createContext();
CartContext.displayName = 'CartContext';
export const CartProvider = ({ children }) => {

  // Update Cart Count of items 
  const [ cartCount, setCartCount] = useState(CartController.getOrCreateCartIfNoExits('es').items.length);
  
  const [showShoppingCart, setShowShoppingCart] = useState(false);
  const [cart, setCart] = useState([]);
  const addToCart = () => {};

  // Update Cart Count of items ENGLISH
  const [ cartCountEn, setCartCountEn] = useState(CartController.getOrCreateCartIfNoExits('en').items.length);

  const [showShoppingCartEn, setShowShoppingCartEn] = useState(false);
  const [cartEn, setCartEn] = useState([]);
  const addToCartEn = () => {};
  

  const value = {
    // CartContext Values
    showShoppingCart,
    setShowShoppingCart,
    cartCount,
    setCartCount,

    // CartContext Values ENGLISH
    cartCountEn, 
    setCartCountEn, 
    showShoppingCartEn,
    setShowShoppingCartEn,  
  };
  
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
